// extracted by mini-css-extract-plugin
module.exports = {"popularProductsContainer":"index_popularProductsContainer___M2J4","homeContent":"index_homeContent__ZTNUV","desc":"index_desc__HhqUz"};